export const BlogDefaultDataset = {
  langMap: [
    {
      langCode: "en",
      title: "",
      summary: "",
      mainContent: [
        {
          displayOrder: 1,
          text: "",
          imageIds: [],
        },
      ],
    },
  ],
};

export const newBlogSectionTemplate = {
  title: "",
  summary: "",
  mainContent: [
    {
      displayOrder: 1,
      text: "",
      imageIds: [],
    },
  ],
};
